// extracted by mini-css-extract-plugin
export default {"button":"aY0l4o"};